import { TextField } from "@mui/material";
import { useSelector } from "react-redux";

import PatientsHeaderSelector from "./PatientsHeaderSelector";
import { inputStyles, inputSearchInHeader } from "@/utils/constants";
import { RootState } from "@/store/store";
import useGetRole from "@/hooks/useGetRole";

import { IPatientsProps } from "@/shared/interfaces/patientPage";

import "./PatientsHeader.scss";
import Title from "@/shared/components/Title/Title";

export default function PatientsHeader({
    handleChange,
    query,
    toggleDrawer,
    handleChangeSortOpton,
    sortOption,
}: IPatientsProps) {
    const dataLength = useSelector((state: RootState) => state.data.dataLength);
    const { isAdmin } = useGetRole();

    return (
        <header className='header_in_content_component header_in_patiens_page'>
            <Title tag='h2' text={"Пацієнти"} />
            <Title
                tag='h3'
                text={`(${dataLength.toString()})`}
                style={{
                    color: "#909DAD",
                    marginTop: 4,
                    marginRight: 8,
                }}
            />

            <div className='header_input_container'>
                <img
                    src='/patients/search.svg'
                    alt='logo search'
                    className='header_input_container_logo'
                />
                <TextField
                    placeholder='Пошук'
                    value={query}
                    onChange={handleChange}
                    sx={{
                        ...inputStyles.root,
                        ...inputSearchInHeader.root,
                    }}
                />
                <PatientsHeaderSelector
                    handleChangeSortOpton={handleChangeSortOpton}
                    sortOption={sortOption}
                />
            </div>
            {isAdmin ? (
                <button
                    className='header_input_add_button'
                    onClick={() => toggleDrawer(true)}
                >
                    <img
                        className='header_input_add_icon'
                        src='/patients/plus.svg'
                        alt='logo plus'
                    />
                    Додати пацієнта
                </button>
            ) : null}
        </header>
    );
}
